import data from "../../../../../src/ProgressBar.docs.json";
import * as React from 'react';
export default {
  data,
  React
};